module.exports = __webpack_public_path__ + "image-02bc8b26a5c6.png";